export const isEmpty = (value: any) => value === "";

export const isEmptyObject = (obj: any) =>
  !!(obj ? Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype : true);

export const validations = {
  isDefaultRequiredValue(value: string | undefined) {
    return value === undefined || value === "";
  },
  isExisty(value: any) {
    return value !== null && value !== undefined;
  },
  matchRegexp(value: any, regexp: any) {
    return !this.isExisty(value) || isEmpty(value) || regexp.test(value);
  },
  isUndefined(value: any) {
    return value === undefined;
  },
  isEmptyString(value: any) {
    return isEmpty(value);
  },

  isMobile(text: any) {
    const mob = /^[1-9]{1}[0-9]{9}/;
    if (text.length != 10) {
      return false;
    }
    const txtMobile = parseInt(text.trim(), 10);
    return mob.test(String(txtMobile));
  },

  isEmail(value: any) {
    return this.matchRegexp(
      value,
      // eslint-disable-next-line no-control-regex, no-useless-escape
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
    );
  },
  isUrl(value: any) {
    return this.matchRegexp(
      value,
      // eslint-disable-next-line no-control-regex, no-useless-escape
      /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
    );
  },
  isTrue(value: any) {
    return value === true;
  },
  isFalse(value: any) {
    return value === false;
  },
  isNumeric(value: any) {
    if (typeof value === "number") {
      return true;
    }
    return this.matchRegexp(value, /^[-+]?(\d*[.])?\d+$/);
  },
  isAlpha(value: any) {
    return this.matchRegexp(value, /^[a-zA-Z]+$/);
  },
  isWords(value: any) {
    return this.matchRegexp(value, /^[a-zA-Z\s]+$/);
  },
  isSpecialWords(value: any) {
    return this.matchRegexp(value, /^[a-zA-Z\s\u00C0-\u017F]+$/);
  },
  isLength(value: any, length: any) {
    return !this.isExisty(value) || isEmpty(value) || value.length === length;
  },
  equals(value: any, eql: any) {
    return !this.isExisty(value) || isEmpty(value) || value == eql;
  },
  maxLength(value: any, length: any) {
    return !this.isExisty(value) || value.length <= length;
  },
  minLength(value: any, length: any) {
    return !this.isExisty(value) || isEmpty(value) || value.length >= length;
  },
};

export default validations;
